"use client";

import { c as _c } from "react/compiler-runtime";
import DropdownToggle from "@/components/Util/DropdownToggle";
import LocationFilterField from "@/components/Util/Filters/LocationFilterField";
import { germanDateFormat } from "@/constants/constants";
import { useTranslation } from "@/app/i18n/client";
import DateFormField from "@/components/Util/FormField/DateFormField";
import { isAfter } from "date-fns";
import KilometerSlider from "../../../_components/map/KilometerSlider";
import { useBusrequestMapContext } from "@/app/[lng]/(mainPages)/buspartner/_components/busrequestmap-context";
import { MdEvent } from "react-icons/md";
type Props = {
  className?: string;
};
export function BusRequestFilterSideBar(t0) {
  const $ = _c(92);
  const {
    className
  } = t0;
  const {
    t,
    i18n
  } = useTranslation();
  const {
    startDateRangeFilter,
    endDateRangeFilter,
    startLocationFilter,
    endLocationFilter,
    setStartDateStart,
    setStartDateEnd,
    setEndDateStart,
    setEndDateEnd,
    setStartLocation,
    setStartRadius,
    setEndLocation,
    setEndRadius
  } = useBusrequestMapContext();
  let t1;
  if ($[0] !== t) {
    t1 = t("MAIN.PAGE_TRAVELCOMPANY.FILTERSIDEBAR.DEPARTURELOCATION");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== setStartLocation || $[3] !== startLocationFilter.location) {
    t2 = <LocationFilterField name="from" setLocation={setStartLocation} initialValue={startLocationFilter.location} />;
    $[2] = setStartLocation;
    $[3] = startLocationFilter.location;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = startLocationFilter.radiusKm ?? 100;
  let t4;
  if ($[5] !== setStartRadius || $[6] !== t3) {
    t4 = <KilometerSlider onChange={setStartRadius} value={t3} />;
    $[5] = setStartRadius;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t4) {
    t5 = <DropdownToggle toggleHeight="6.5rem" title={t1} initiallyOpen={true}>{t2}{t4}</DropdownToggle>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("MAIN.PAGE_TRAVELCOMPANY.FILTERSIDEBAR.DESTINATION");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== endLocationFilter.location || $[15] !== setEndLocation) {
    t7 = <LocationFilterField name="to" setLocation={setEndLocation} initialValue={endLocationFilter.location} />;
    $[14] = endLocationFilter.location;
    $[15] = setEndLocation;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = endLocationFilter.radiusKm ?? 100;
  let t9;
  if ($[17] !== setEndRadius || $[18] !== t8) {
    t9 = <KilometerSlider onChange={setEndRadius} value={t8} />;
    $[17] = setEndRadius;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t6 || $[21] !== t7 || $[22] !== t9) {
    t10 = <DropdownToggle toggleHeight="6.5rem" title={t6} initiallyOpen={false}>{t7}{t9}</DropdownToggle>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t("MAIN.PAGE_TRAVELCOMPANY.FILTERSIDEBAR.DEPARTUREDATE");
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = startDateRangeFilter[0] ?? undefined;
  const t13 = !!startDateRangeFilter[0];
  const t14 = i18n.language;
  let t15;
  if ($[26] !== setStartDateEnd || $[27] !== setStartDateStart || $[28] !== startDateRangeFilter[1]) {
    t15 = date => {
      if (date && startDateRangeFilter[1] && isAfter(date, startDateRangeFilter[1])) {
        setStartDateEnd(null);
      }
      setStartDateStart(date ?? null);
    };
    $[26] = setStartDateEnd;
    $[27] = setStartDateStart;
    $[28] = startDateRangeFilter[1];
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="icon"><MdEvent /></div>;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t) {
    t17 = t("MAIN.PAGE_TRAVELCOMPANY.FILTERSIDEBAR.START");
    $[31] = t;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== i18n.language || $[34] !== t12 || $[35] !== t13 || $[36] !== t15 || $[37] !== t17) {
    t18 = <DateFormField name="dateOutwardStart" selected={t12} isClearable={t13} locale={t14} onChange={t15} icon={t16} label={t17} dontDisplayTime={true} dateFormat={germanDateFormat} noAutomaticReplacementDate={true} wrapperClassName="mb-4" childClassName="border-solid border-matchbus border-0 border-b-2" labelClassName="font-bold italic text-sm" noOldFormClasses={true} data-sentry-unmask={true} />;
    $[33] = i18n.language;
    $[34] = t12;
    $[35] = t13;
    $[36] = t15;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const t19 = startDateRangeFilter[1] ?? undefined;
  const t20 = !!startDateRangeFilter[1];
  const t21 = i18n.language;
  let t22;
  if ($[39] !== setStartDateEnd) {
    t22 = date_0 => {
      setStartDateEnd(date_0 ?? null);
    };
    $[39] = setStartDateEnd;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="icon"><MdEvent /></div>;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  const t24 = startDateRangeFilter[0] ?? undefined;
  let t25;
  if ($[42] !== t) {
    t25 = t("MAIN.PAGE_TRAVELCOMPANY.FILTERSIDEBAR.END");
    $[42] = t;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== i18n.language || $[45] !== t19 || $[46] !== t20 || $[47] !== t22 || $[48] !== t24 || $[49] !== t25) {
    t26 = <DateFormField name="dateOutwardEnd" selected={t19} isClearable={t20} locale={t21} onChange={t22} icon={t23} minDate={t24} dontDisplayTime={true} label={t25} dateFormat={germanDateFormat} noAutomaticReplacementDate={true} wrapperClassName="mb-4" childClassName="border-solid border-matchbus border-0 border-b-2" labelClassName="font-bold italic text-sm" noOldFormClasses={true} data-sentry-unmask={true} />;
    $[44] = i18n.language;
    $[45] = t19;
    $[46] = t20;
    $[47] = t22;
    $[48] = t24;
    $[49] = t25;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== t11 || $[52] !== t18 || $[53] !== t26) {
    t27 = <DropdownToggle title={t11} toggleHeight="10rem" initiallyOpen={false}>{t18}{t26}</DropdownToggle>;
    $[51] = t11;
    $[52] = t18;
    $[53] = t26;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t) {
    t28 = t("MAIN.PAGE_TRAVELCOMPANY.FILTERSIDEBAR.RETURNDATE");
    $[55] = t;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  const t29 = endDateRangeFilter[0] ?? undefined;
  const t30 = !!endDateRangeFilter[0];
  const t31 = i18n.language;
  let t32;
  if ($[57] !== endDateRangeFilter[1] || $[58] !== setEndDateEnd || $[59] !== setEndDateStart) {
    t32 = date_1 => {
      if (date_1 && endDateRangeFilter[1] && isAfter(date_1, endDateRangeFilter[1])) {
        setEndDateEnd(null);
      }
      setEndDateStart(date_1 ?? null);
    };
    $[57] = endDateRangeFilter[1];
    $[58] = setEndDateEnd;
    $[59] = setEndDateStart;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  let t33;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <div className="icon"><MdEvent /></div>;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] !== t) {
    t34 = t("MAIN.PAGE_TRAVELCOMPANY.FILTERSIDEBAR.START");
    $[62] = t;
    $[63] = t34;
  } else {
    t34 = $[63];
  }
  let t35;
  if ($[64] !== i18n.language || $[65] !== t29 || $[66] !== t30 || $[67] !== t32 || $[68] !== t34) {
    t35 = <DateFormField name="dateReturnStart" selected={t29} isClearable={t30} locale={t31} onChange={t32} icon={t33} label={t34} dontDisplayTime={true} dateFormat={germanDateFormat} noAutomaticReplacementDate={true} wrapperClassName="mb-4" childClassName="border-solid border-matchbus border-0 border-b-2" labelClassName="font-bold italic text-sm" noOldFormClasses={true} data-sentry-unmask={true} />;
    $[64] = i18n.language;
    $[65] = t29;
    $[66] = t30;
    $[67] = t32;
    $[68] = t34;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  const t36 = endDateRangeFilter[1] ?? undefined;
  const t37 = !!endDateRangeFilter[1];
  const t38 = i18n.language;
  let t39;
  if ($[70] !== setEndDateEnd) {
    t39 = date_2 => {
      setEndDateEnd(date_2 ?? null);
    };
    $[70] = setEndDateEnd;
    $[71] = t39;
  } else {
    t39 = $[71];
  }
  let t40;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <div className="icon"><MdEvent /></div>;
    $[72] = t40;
  } else {
    t40 = $[72];
  }
  const t41 = endDateRangeFilter[0] ?? undefined;
  let t42;
  if ($[73] !== t) {
    t42 = t("MAIN.PAGE_TRAVELCOMPANY.FILTERSIDEBAR.END");
    $[73] = t;
    $[74] = t42;
  } else {
    t42 = $[74];
  }
  let t43;
  if ($[75] !== i18n.language || $[76] !== t36 || $[77] !== t37 || $[78] !== t39 || $[79] !== t41 || $[80] !== t42) {
    t43 = <DateFormField name="dateReturnEnd" selected={t36} isClearable={t37} locale={t38} onChange={t39} icon={t40} minDate={t41} dontDisplayTime={true} label={t42} dateFormat={germanDateFormat} noAutomaticReplacementDate={true} wrapperClassName="mb-4" childClassName="border-solid border-matchbus border-0 border-b-2" labelClassName="font-bold italic text-sm" noOldFormClasses={true} data-sentry-unmask={true} />;
    $[75] = i18n.language;
    $[76] = t36;
    $[77] = t37;
    $[78] = t39;
    $[79] = t41;
    $[80] = t42;
    $[81] = t43;
  } else {
    t43 = $[81];
  }
  let t44;
  if ($[82] !== t28 || $[83] !== t35 || $[84] !== t43) {
    t44 = <DropdownToggle title={t28} toggleHeight="10rem" initiallyOpen={false}>{t35}{t43}</DropdownToggle>;
    $[82] = t28;
    $[83] = t35;
    $[84] = t43;
    $[85] = t44;
  } else {
    t44 = $[85];
  }
  let t45;
  if ($[86] !== className || $[87] !== t10 || $[88] !== t27 || $[89] !== t44 || $[90] !== t5) {
    t45 = <div className={className}>{t5}{t10}{t27}{t44}</div>;
    $[86] = className;
    $[87] = t10;
    $[88] = t27;
    $[89] = t44;
    $[90] = t5;
    $[91] = t45;
  } else {
    t45 = $[91];
  }
  return t45;
}